
export const OfficialDispatchEN = {
    "official-dispatch" : "Official dispatch" ,
    incoming: "Incoming official dispatch",
    outgoing: "Outgoing official dispatch",
    draft : "Draft official dispatch",
    "owned-by-me" : "Owned by me",
    "followed-by-me" : "Followed by me",
    "performed-by-me" : "Performed by me",
    "process-type": "Process template",
    "book-type" : "Book No.",
    "book" : "Book No.",
    "incoming-book" : "Incoming book",
    "outgoing-book" : "Outgoing book",
    "address" : "List of Recipient/Sender"
}